import "styles/components/forms/inputs/toggleInput.css";
import { ToggleFieldType } from "shared/types";
import React from "react";

const ToggleInput = ({ options, required, id, className }: ToggleFieldType) => {
  return (
    <div className={className} key={id}>
      {options.map((option) => (
        <React.Fragment key={option.id}>
          <input
            type="radio"
            value={option.id}
            name={`${id}`}
            id={option.id}
            required={required}
          />
          <label className="toggle-label" htmlFor={option.id}>
            {option.value}
          </label>
        </React.Fragment>
      ))}
    </div>
  );
};

export default ToggleInput;
